import React from 'react'
import PropTypes from 'prop-types'
import { formatterMoney } from 'utils/format'
import {
  Container,
  Total,
  Label,
  Legend,
} from './styles'

export default function Totals({ totals }) {
  return (
    <Container>
      <h3>Total</h3>
      <Total>
        <Label>
          <Legend className="dark-yellow" />
          Pago com voucher:
        </Label>
        <div>{formatterMoney(totals.used_vouchers)}</div>
      </Total>
      <Total>
        <Label>
          <Legend className="green" />
          Vouchers gerados:
        </Label>
        <div>{formatterMoney(totals.generated_vouchers)}</div>
      </Total>
      <Total>
        <Label>
          <Legend className="orange" />
          Descontos:
        </Label>
        <div>{formatterMoney(totals.discount)}</div>
      </Total>
      <Total>
        <Label>
          <Legend className="blue" />
          Total:
        </Label>
        <div>{formatterMoney(totals.total)}</div>
      </Total>
    </Container>
  )
}

Totals.propTypes = {
  totals: PropTypes.objectOf(PropTypes.any),
}

Totals.defaultProps = {
  totals: {},
}
